"use client";
import { useState } from "react";

const PREVIEW_COUNT = 3;

export default function EventDescription({ description }) {
  const [expanded, setExpanded] = useState(false);

  const allBlocks = description ?? [];
  if (allBlocks.length === 0) return null;

  const hasMore = allBlocks.length > PREVIEW_COUNT;
  const visibleBlocks = expanded ? allBlocks : allBlocks.slice(0, PREVIEW_COUNT);

  return (
    <section className="max-w-[var(--max-page-width)] px-[var(--container-padding)] mx-auto mt-10">
      <div className="flex items-center gap-3 mb-5">
        <span className="w-1 h-5 rounded-full bg-[#005D82]" />
        <h2 className="text-[17px] font-semibold text-gray-800">About the Event</h2>
      </div>

      <div className="relative">
        <div className="space-y-4 text-[15px] leading-[1.85] text-gray-700">
          {visibleBlocks.map((block, i) => {
            const text = block?.children?.map((c) => c.text).join(" ");
            if (!text?.trim()) return null;
            return <p key={i}>{text}</p>;
          })}
        </div>

        {!expanded && hasMore && (
          <div className="absolute bottom-0 left-0 right-0 h-20 bg-gradient-to-t from-white to-transparent pointer-events-none" />
        )}
      </div>

      {hasMore && (
        <button
          onClick={() => setExpanded(!expanded)}
          className="mt-4 inline-flex items-center gap-1.5 text-[13px] font-semibold text-[#005D82] hover:text-[#004a68] transition-colors"
        >
          {expanded ? "See Less" : "See More"}
          <svg
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.2"
            strokeLinecap="round"
            className={`transition-transform duration-300 ${expanded ? "rotate-180" : "rotate-0"}`}
          >
            <path d="M6 9l6 6 6-6" />
          </svg>
        </button>
      )}

      <div className="mt-10 border-t border-gray-100" />
    </section>
  );
}
